import { useTranslations } from '@vocab/react';
import { Badge } from 'braid-design-system';
import type { FC } from 'react';
import translations from './.vocab';

export const BillableBadge: FC = () => {
  const { t } = useTranslations(translations);
  return <Badge tone="promote">{t('Billable')}</Badge>;
};
